import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SECTIONS = [
  {
    title: '1. Kişisel Verilerin Toplanması',
    content: `Ankara Travelers olarak, hizmetlerimizden yararlanmanız sırasında çeşitli kişisel verilerinizi toplamaktayız. Bu veriler; ad-soyad, e-posta adresi, telefon numarası, TC kimlik numarası (pasaport bilgileri), ödeme bilgileri ve rezervasyon geçmişinizden oluşmaktadır.\n\nVerilerinizi; web sitemiz üzerinden rezervasyon formları, telefon görüşmeleri, e-posta yazışmaları ve çerezler (cookies) aracılığıyla topluyoruz.`,
  },
  {
    title: '2. Kişisel Verilerin Kullanım Amaçları',
    content: `Topladığımız kişisel veriler yalnızca aşağıdaki amaçlarla kullanılmaktadır:\n\n• Rezervasyon ve tur satın alma işlemlerinin gerçekleştirilmesi\n• Ödeme işlemlerinin güvenli biçimde yapılması\n• Size özel kampanya ve tekliflerin iletilmesi (onay vermeniz halinde)\n• Yasal yükümlülüklerin yerine getirilmesi\n• Hizmet kalitemizin iyileştirilmesi\n• Müşteri destek hizmetlerinin sunulması`,
  },
  {
    title: '3. Kişisel Verilerin Üçüncü Taraflarla Paylaşımı',
    content: `Kişisel verileriniz; yasal yükümlülükler dışında üçüncü taraflarla satılmaz veya kiralanmaz. Ancak tur operasyonlarının yürütülmesi amacıyla aşağıdaki taraflarla sınırlı ölçüde paylaşılabilir:\n\n• Otel ve konaklama tesisleri (rezervasyon bilgileri)\n• Havayolu şirketleri (uçuş rezervasyonları)\n• Tur rehberleri ve taşıma firmaları\n• Ödeme altyapısı sağlayıcıları (şifreli ve güvenli)\n\nBu paylaşımlar yalnızca hizmet sunumu için zorunlu olduğunda gerçekleştirilir.`,
  },
  {
    title: '4. Çerezler (Cookies)',
    content: `Web sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanmaktadır. Çerezler; oturum bilgilerini, dil tercihlerinizi ve site içi davranışlarınızı saklar.\n\nTarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz. Ancak bu durumda bazı site özelliklerinin tam olarak çalışmayabileceğini belirtmek isteriz.`,
  },
  {
    title: '5. Veri Güvenliği',
    content: `Kişisel verileriniz, endüstri standartlarında SSL şifrelemesi ve güvenlik protokolleriyle korunmaktadır. Ödeme bilgileriniz hiçbir koşulda sunucularımızda saklanmaz; tüm ödemeler PCI-DSS uyumlu ödeme altyapıları üzerinden gerçekleştirilir.\n\nVeri güvenliğini sağlamak amacıyla düzenli güvenlik denetimleri yapılmakta ve personelinimiz veri güvenliği konusunda eğitilmektedir.`,
  },
  {
    title: '6. Haklarınız',
    content: `6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında aşağıdaki haklara sahipsiniz:\n\n• Kişisel verilerinizin işlenip işlenmediğini öğrenme\n• İşlenen verileriniz hakkında bilgi talep etme\n• Verilerin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme\n• Verilerinizin düzeltilmesini veya silinmesini talep etme\n• İşlemenin kısıtlanmasını talep etme\n\nBu haklarınızı kullanmak için info@ankaratravelers.com adresine e-posta gönderebilirsiniz.`,
  },
  {
    title: '7. Politika Güncellemeleri',
    content: `Bu Gizlilik Politikası zaman zaman güncellenebilir. Önemli değişiklikler web sitemizde duyurulacak ve gerektiğinde e-posta ile bilgilendirileceksiniz. Politikanın güncel halini düzenli olarak incelemenizi tavsiye ederiz.\n\nSon güncelleme: Ocak 2025`,
  },
];

export default function GizlilikPolitikasiPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/gizlilik-politikasi`,
    url: `${siteUrl}/gizlilik-politikasi`,
    name: 'Gizlilik Politikası | Ankara Travelers',
    description: 'Ankara Travelers gizlilik politikası. KVKK uyumlu kişisel veri işleme, saklama ve koruma ilkeleri.',
    inLanguage: 'tr-TR',
    dateModified: '2025-01-01',
    publisher: {
      '@type': 'TravelAgency',
      name: 'Ankara Travelers',
    },
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <title>Gizlilik Politikası | Ankara Travelers</title>
      <meta name="description" content="Ankara Travelers gizlilik politikası. KVKK kapsamında kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu öğrenin. Veri güvenliğiniz önceliğimizdir." />
      <meta name="keywords" content="Ankara Travelers gizlilik politikası, KVKK, kişisel veri koruma" />
      <link rel="canonical" href={`${siteUrl}/gizlilik-politikasi`} />
      <meta property="og:title" content="Gizlilik Politikası | Ankara Travelers" />
      <meta property="og:url" content={`${siteUrl}/gizlilik-politikasi`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }}
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-20 bg-gray-900 dark:bg-gray-950">
        <div className="max-w-3xl mx-auto px-6 py-20 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
            <i className="ri-shield-check-line text-3xl text-orange-400" />
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">Gizlilik Politikası</h1>
          <p className="text-gray-400 text-base">Son güncelleme: Ocak 2025</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          {/* Intro */}
          <div className="bg-orange-50 dark:bg-orange-900/10 border border-orange-100 dark:border-orange-800/30 rounded-xl p-6 mb-10">
            <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
              Ankara Travelers olarak kişisel verilerinizin gizliliğine ve güvenliğine büyük önem veriyoruz. Bu Gizlilik Politikası, sitemizi ziyaret ettiğinizde veya hizmetlerimizden yararlandığınızda hangi verilerin toplandığını, nasıl kullanıldığını ve korunduğunu açıklamaktadır.
            </p>
          </div>

          <div className="space-y-8">
            {SECTIONS.map(sec => (
              <div key={sec.title} className="border-b border-gray-100 dark:border-gray-800 pb-8 last:border-0">
                <h2 className="text-base font-bold text-gray-900 dark:text-white mb-4">{sec.title}</h2>
                <div className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed whitespace-pre-line">
                  {sec.content}
                </div>
              </div>
            ))}
          </div>

          {/* Contact */}
          <div className="mt-12 bg-gray-50 dark:bg-gray-800 rounded-xl p-6">
            <h3 className="font-bold text-gray-900 dark:text-white mb-2">İletişim</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Gizlilik politikamızla ilgili sorularınız için:
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-orange-500" />
                </div>
                info@ankaratravelers.com
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-orange-500" />
                </div>
                Kızılay, Ankara, Türkiye
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
